module.exports = __webpack_public_path__ + "src/client/assets/icons/amendments.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/icons/amendments.png
// module id = 1200
// module chunks = 0